import toast from "react-hot-toast";

export function error(text) {
  toast.error(text);
}
